import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

const resolveUrl = (url) => (url.startsWith('http') ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

const MovementImage = ({ url, alt, testId, onFail }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="relative flex-1 min-w-0 max-w-[10rem] aspect-square rounded-xl overflow-hidden bg-zinc-900 border border-white/5">
      {!loaded && <div className="absolute inset-0 animate-pulse bg-zinc-800/60" />}
      <img
        src={resolveUrl(url)}
        alt={alt}
        loading="lazy"
        decoding="async"
        width={160}
        height={160}
        onLoad={() => setLoaded(true)}
        onError={onFail}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        data-testid={testId}
      />
    </div>
  );
};

export const ExerciseMovementImages = ({ exercise, dimmed, className = 'mt-2' }) => {
  const [failed, setFailed] = useState({});
  const images = [
    { key: 'start', url: exercise.start_image_url, alt: 'Posição inicial' },
    { key: 'end', url: exercise.end_image_url, alt: 'Posição final' },
  ].filter((img) => img.url && !failed[img.key]);

  if (images.length === 0) return null;

  return (
    <div
      className={`flex items-center gap-2 ${className} ${dimmed ? 'opacity-40' : ''}`}
      data-testid={`exercise-images-${exercise.id}`}
    >
      {images.map((img, i) => (
        <React.Fragment key={img.key}>
          {i > 0 && <ArrowRight className="w-4 h-4 text-neon-lime/70 flex-shrink-0" />}
          <MovementImage
            url={img.url}
            alt={img.alt}
            testId={`exercise-${img.key}-image-${exercise.id}`}
            onFail={() => setFailed((f) => ({ ...f, [img.key]: true }))}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
